<template>
  <div class="ProductComment">
    <div class="custom_back_header">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        @click="goBack()"
      >
        <g fill="#FFF" fill-rule="evenodd">
          <path
            d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            style="    fill: #000;"
          />
          <path
            d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            style="    fill: #000;"
          />
        </g>
      </svg>
      <h3>{{details.commentCount}} {{$t('peoplecomments')}}</h3>
    </div>
    <ul class="product_comment">
      <li v-for="(comment,index) in comments" :key="index">
        <div class="user_detail">
          <div class="user_img" @click="openUserProfile(comment.xAuthId)">
            <img src="../../assets/images/dummy.png" class="wdth100" alt="dummy" />
          </div>
          <div class="user_profile">
            <h3>{{comment.name}}</h3>
            <div class="time_stamp">{{comment.timeAgo}}</div>
            <span class="comment_text">{{comment.comment}}</span>
          </div>
        </div>
      </li>
    </ul>
    <infinite-loading @infinite="getComments" spinner="circles">
      <template slot="no-more">और रिकॉर्ड उपलब्ध नहीं है</template>
    </infinite-loading>

    <div class="order_button">
      <button type="button" class="view_all_btn input_btn">
        <input type="text" placeholder="कमैंट्स लिखें " v-model="comment" />
        <i class="material-icons" @click="sendMessage('normal')">send</i>
      </button>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="watermark" />
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";

export default {
  name: "ProductComment",
  data() {
    return {
      comments: [],
      comment: "",
      details: {},
      loading: false,
      commentIndex: 0,
      commentLimit: 20,
      allDetails: []
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getComments($state) {
      if ($state) {
        setTimeout(() => {
          if (this.commentIndex != -1) {
            this.$store
              .dispatch({
                type: "getCommentsBySale",
                payload: this.$route.params.saleReferenceID,
                limit: this.commentLimit,
                index: this.commentIndex
              })
              .then(data => {
                $state && $state.loaded();
                if (data.data.commentDTOs.length > 0) {
                  this.commentIndex = this.commentIndex + 1;
                  this.comments = this.comments.concat(data.data.commentDTOs);
                  let commentsData = {
                    comments: this.comments,
                    id: this.$route.params.saleReferenceID
                  };
                  this.$store.commit("commentList", {
                    commentsData: commentsData,
                    commentIndex: this.commentIndex + 1
                  });

                  this.loading = false;
                } else {
                  this.commentIndex = -1;
                  this.loading = false;
                  $state && $state.complete();
                }
              })
              .catch(err => {
                let obj = {
                  status: "Failure",
                  timeoutMs: "5000"
                };
                bus.$emit("apiStatus", obj);
              });
          }
        }, 1000);
      }
    },
    sendMessage() {
      var obj = {
        saleReferenceID: this.$route.params.saleReferenceID,
        comment: this.comment,
        location: "agra"
      };
      this.loading = true;
      if (this.comment) {
        this.$store
          .dispatch({
            type: "addComment",
            payload: obj
          })
          .then(data => {
            this.comments.unshift(data.data);
            this.comment = " ";
            this.details.commentCount = Number(this.details.commentCount) + 1;
            this.$store.commit("saveComments", {
              comments: this.comments,
              saleID: this.details.saleReferenceID
            });
            this.$store.commit("incrementLikeCommentCount", {
              type: "comment",
              saleReferenceID: this.$route.params.saleReferenceID
            });
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
            let obj = {
              status: "Failure",
              timeoutMs: "5000"
            };
            bus.$emit("apiStatus", obj);
          });
      } else {
        this.loading = false;
        let obj = {
          status: "CommentInputError",
          timeoutMs: "5000"
        };
        bus.$emit("apiStatus", obj);
      }
    },
    openUserProfile(XAUTHID) {
      try {
        JSBridgePlugin.showNativeProfileView(XAUTHID);
      } catch (err) {
        console.log(err);
      }
    },
    getProductDetail() {
      this.$data.saleReferenceID = this.$route.params.saleReferenceID;
      const obj = {
        saleReferenceID: this.$route.params.saleReferenceID,
        referralUserId: this.$route.params.encodedId,
        orderSourceType: this.orderSourceType
      };
      this.$store
        .dispatch({
          type: "getProductDetail",
          payload: obj
        })
        .then(data => {
          this.loading = false;
          this.details = data.data;
          this.$store.commit("PRODUCTDETAIL", data.data);
        });
    }
  },
  mounted() {
    this.getProductDetail();
  }
};
</script>
<style scoped>
.prdt_like li .user_img {
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
  height: 45px;
}
</style>